import React, {useContext, useEffect, useState, useCallback} from 'react';

import {Button} from 'views/AppElements';

import {A, Separator, Img} from 'views/AppElements';
import UserAvatar from 'views/user/UserAvatar';
import ImgUploadForm from 'views/ImgUploadForm';
import {OrderContext} from 'views/order/OrderForm';
import PhotoFrameImg from 'views/order/PhotoFrameImg';
import AppUtil from 'AppUtil';

const FrameImageUploader = ({isCustomProduct, imgSrc}) => {
    const {product, values, setFieldValue} = useContext(OrderContext);
    const [loadedImg, setLoadedImg] = useState(null);//the actual image object
    
    const creatorURL = AppUtil.getDesignerURL(product.creator);
    const createrName = product.creator? AppUtil.getCreaterName(product.creator): null;
    useEffect(() => {
        if(loadedImg && isCustomProduct) {
            let imgWidthPixel = loadedImg? (loadedImg.naturalWidth || loadedImg.width): 0, 
            imgHeightPixel = loadedImg? (loadedImg.naturalHeight || loadedImg.height): 0;

            setFieldValue('imgWidth', imgWidthPixel);
            setFieldValue('imgHeight', imgHeightPixel);
        }
    }, [loadedImg]);

    const resetImg = useCallback(() => {
        setFieldValue('customerUploadedImage', null);
        setLoadedImg(null);
        setFieldValue("productSizeMetaData", '');
        setFieldValue("productSize", '');
        setFieldValue('imgWidth', '');
        setFieldValue('imgHeight', '');

        setFieldValue('isCustomSize', '');
        setFieldValue('customWidth', '');
        setFieldValue('customHeight', '');
    });

    const borderClassName = values.borderColor || "blackBorder";
    return <div className="flexColumn" id="photoUploadSection">
            {
                isCustomProduct &&
                <h2 style={{textAlign: 'center', margin: '0 0 20px 0', color: '#1c1c1e', fontSize: '2.5rem', fontWeight: '600'}}>[ <span style={{fontSize: '90%', textDecoration: 'underline'}}>Frame Your Photo</span> ]</h2>
            }
            {
                !isCustomProduct &&
                <div style={{textAlign: 'center'}} className="flexColumn">
                        <h1 className='flexColumn productTitle'>
                            <span>{product.title}</span>
                        </h1>

                        

                        {product.creator &&
                            <div className="flexRow" style={{alignItems: "center", justifyContent: "center"}}>
                                <A href={creatorURL}><UserAvatar user={product.creator} /></A>
                                    <span style={{color: '#5b5b5b', fontSize: '90%'}}>from <A href={creatorURL} style={{color: '#f8931b', textTransform: 'capitalize', fontWeight: 'bold'}}>
                                            {createrName}
                                    </A>
                                    </span>
                            </div>
                        }

                        <Separator />
                        
                    </div>
            }
            
            {values.customerUploadedImage === null && isCustomProduct &&
                <div id="photoFrameImgUploader" className={borderClassName}>
                    <span id="uploadText">Upload Your Image</span>
                    <ImgUploadForm previewId="customerImageFile" className="cutomOrderImageForm"  
                            imgWidth="100px" imgHeight="100px"
                            onImgChange={(uploadedImgFile) => {
                                setFieldValue('customerUploadedImage', uploadedImgFile);
                            }} 

                            onImgReset={resetImg}
                        />
                </div>
            }
                
            {(values.customerUploadedImage !== null || (isCustomProduct !== true && imgSrc !== null)) && 

                <React.Fragment>
                    <PhotoFrameImg id="customFrameImgPreview" 
                                    imgUrl={imgSrc}
                                    imgFile={values.customerUploadedImage}
                                    matting={values.matting} 
                                    borderColor={values.borderColor}
                                    onImgLoad={(img) => {
                                        setLoadedImg(img);
                                    }} />

                    {
                        isCustomProduct &&
                        <Button mui="true" variant="danger" id="removePhotoImg" onClick={resetImg}>Remove Image</Button>
                    }
                </React.Fragment>
            }

            
            
            {!isCustomProduct && product.description &&
                <span style={{display: 'block', color: 'gray', textAlign: 'center', margin: '5px 0 10px 0', fontSize: '100%', whiteSpace: 'pre-line'}}>- {product.description}</span>	
            }

            <div id="customFrameInfo" style={{margin: '10px auto'}}>
                <ul style={{marginTop: '5px'}}>
                    <li>Photo Frame border is 1" in Width.</li>
                    <li>Made up of Light Fiber Frame.</li>
                    <li>Fiber glass used for maximum durability and quality.</li>
                    <li><Img src="/images/nepal flag.png" title="Nepal Flag" alt="Nepal Flag" style={{height: "12px", marginLeft: "3px"}}/> Made in Nepal</li>
                </ul>
            </div>
        </div>
}


export default FrameImageUploader;


// WEBPACK FOOTER //
// ./src/views/order/input/FrameImageUploader.js